export enum Role {
	PORTAL_ADMIN = 'PORTAL_ADMIN',
	CUSTOMER_ADMIN = 'CUSTOMER_ADMIN',
	ROLE_RM = 'ROLE_RM',
	ROLE_BM = 'ROLE_BM',
	ROLE_PM = 'ROLE_PM',
	ROLE_USER = 'ROLE_USER',
	ROLE_VENDOR = 'ROLE_VENDOR',
	ROLE_CREW_LEAD = 'ROLE_CREW_LEAD',
	ROLE_RMV = 'ROLE_RMV',
	ROLE_BMV = 'ROLE_BMV',
	ROLE_LV = 'ROLE_LV',
}
